import { render, staticRenderFns } from "./GradientChart.vue?vue&type=template&id=4151838c&scoped=true&"
import script from "./GradientChart.vue?vue&type=script&lang=ts&"
export * from "./GradientChart.vue?vue&type=script&lang=ts&"
import style0 from "./GradientChart.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GradientChart.vue?vue&type=style&index=1&id=4151838c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4151838c",
  null
  
)

export default component.exports